import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"60px"}
}
const _hoisted_3 = { class: "container-flex m-5" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "fg-color-gray d-flex justify-content-between align-items-center p-1 mb-2",
  style: {"white-space":"nowrap"}
}
const _hoisted_6 = { class: "text-right mb-0" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  class: "card",
  style: {"box-shadow":"0 0 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_9 = {
  class: "card-body",
  style: {"background-color":"#f4f4f4"}
}
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  class: "list-unstyled w-100",
  style: {"height":"150px","overflow-x":"hidden","overflow-y":"auto"}
}
const _hoisted_12 = ["href", "target", "title"]
const _hoisted_13 = ["innerHTML"]

import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute } from 'vue-router'
    import { useDashboardPage } from '@Organizations/Users/pages-core'
    import Navigation from '@common/Navigation.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardPage',
  setup(__props) {

    const { useUserDashboardQuery } = useDashboardPage()
    const { modelUserDashboardQueryV1, runUserDashboardQueryV1, authorized, completed } = useUserDashboardQuery()
    const categories = computed(() => modelUserDashboardQueryV1.value?.Categories || [])
    const logoUrl = computed(() => modelUserDashboardQueryV1.value?.LogoUrl)

    document.title = "TransparentChoice Dashboard"

    onMounted(() => runUserDashboardQueryV1())

    //watch(authorized, () => {
    //    if (authorized.value === false) {
    //        location.href = '/#/signin';
    //    }
    //})

return (_ctx: any,_cache: any) => {
  return (_unref(completed))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Navigation)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: logoUrl.value,
            alt: "Logo",
            class: "mr-2 rounded-circle",
            style: {"max-height":"100px"}
          }, null, 8 /* PROPS */, _hoisted_4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (c, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: c.id,
              class: "p-2"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("hr", {
                  class: "m-0",
                  style: {"width":"100%"}
                }, null, -1 /* CACHED */)),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "  ", -1 /* CACHED */)),
                _createElementVNode("h5", _hoisted_6, [
                  (c.CategoryIcon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(["fa", [`fa-${c.CategoryIcon}`]]),
                        "aria-hidden": "true"
                      }, null, 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                  _createTextVNode(" " + _toDisplayString(c.Title), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.Items, (s) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: s.id,
                    class: "col-sm-6 col-lg-4 mb-4"
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("h5", {
                          class: "fg-color-blue card-title text-ellipsis",
                          title: s.Title
                        }, _toDisplayString(s.Title), 9 /* TEXT, PROPS */, _hoisted_10),
                        _createElementVNode("ul", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.Items, (i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i.id,
                              class: "mb-2 highlight-on-hover"
                            }, [
                              _createElementVNode("a", {
                                href: i.Url,
                                target: i.OpenInNewWindow ? '_blank' : '_self',
                                title: i.Title,
                                class: "d-flex justify-content-between align-items-center card-link fg-color-gray",
                                style: {"border-bottom":"1px dotted lightgray","padding-bottom":"3px"}
                              }, [
                                _createElementVNode("span", {
                                  class: "text-ellipsis",
                                  style: {"max-width":"70%","overflow":"hidden","white-space":"nowrap"},
                                  innerHTML: i.Title
                                }, null, 8 /* PROPS */, _hoisted_13),
                                (i.DueDateText)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      title: "Due date",
                                      class: _normalizeClass(['due-date-badge', i.DueDateClass]),
                                      style: {"white-space":"nowrap","font-size":"0.95em"}
                                    }, _toDisplayString(i.DueDateText), 3 /* TEXT, CLASS */))
                                  : _createCommentVNode("v-if", true)
                              ], 8 /* PROPS */, _hoisted_12)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */))
      ]))
    : _createCommentVNode("v-if", true)
}
}

})